import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsUngatedToAIProjections, getIsUngatedToForecastingMultipleOutcomes } from '../selectors/authSelectors';
import { TEAMS } from '../constants/OverviewConstants';

// Only import and use "containers" for your route
import RepOverviewContainer from '../containers/RepOverviewContainer';
import RepDetailContainer from '../containers/RepDetailContainer';
import AnalyzeContainer from '../containers/AnalyzeContainer';
import { CreateForecastTypeWizardWrapper } from '../components/fmo/CreateForecastTypeWizardWrapper';
import { getLastSavedTeam } from '../utils/filters';
import { ANALYZE_ROUTE, CREATE_FORECAST_ROUTE } from '../constants/Tabs';
import { useFilterCoordination } from '../hooks/useFilterCoordination';
import { useQueryParams } from '../hooks/useQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Routes(props) {
  // Makes sure dependent filters are in sync
  useFilterCoordination();
  // Makes sure query params are in sync with filters
  useQueryParams();
  const isUngatedToAIProjections = useSelector(getIsUngatedToAIProjections);
  const isUngatedToFMO = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  let teamId = getLastSavedTeam();
  if (!teamId && props.primaryTeam) {
    teamId = props.primaryTeam.id;
  }
  const teamPath = teamId ? `/teams/${teamId}?` : '/teams';
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/owner/:ownerId?",
      component: RepDetailContainer
    }), /*#__PURE__*/_jsx(Route, {
      path: `/${TEAMS}/:teamId?`,
      component: RepOverviewContainer
    }), isUngatedToAIProjections && /*#__PURE__*/_jsx(Route, {
      path: ANALYZE_ROUTE,
      component: AnalyzeContainer
    }), isUngatedToFMO && /*#__PURE__*/_jsx(Route, {
      path: CREATE_FORECAST_ROUTE,
      component: CreateForecastTypeWizardWrapper
    }), /*#__PURE__*/_jsx(Route, {
      path: "*",
      children: /*#__PURE__*/_jsx(Redirect, {
        to: teamPath
      })
    })]
  });
}